import * as React from 'react';
import {
  Chat,
  createChatInstance,
  type ChatInstance,
} from '@leagueplatform/chat';
import { usePersonalInformation } from '@scfhp-web/shared-module';

const ChatInstanceContext = React.createContext<ChatInstance | null>(null);

export const useChatInstance = () => React.useContext(ChatInstanceContext);

export const ChatSessionProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { data } = usePersonalInformation();
  const memberId = data?.userId as string | undefined;

  const chatInstance = React.useMemo(
    () => (memberId ? createChatInstance() : null),
    [memberId],
  );

  // ChatInstance has no public disposal method, so ending the session is how a
  // sign-out or member change releases it.
  React.useEffect(() => {
    if (!chatInstance) return undefined;

    return () => {
      chatInstance.actor.send({ type: 'USER_END_CHAT' });
    };
  }, [chatInstance]);

  return (
    <ChatInstanceContext.Provider value={chatInstance}>
      {children}
      {chatInstance && <Chat chatInstance={chatInstance} />}
    </ChatInstanceContext.Provider>
  );
};
